import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
  TaskType,
  Timestamp,
} from '@griply/types';

import { createDefaultCompletedFilterDocument } from './constants/default-completed-filter-document';

export const getCompletedFilterDocument = (
  today: Timestamp,
  showHabits: boolean,
): FilterDocument => {
  const filterDocument = createDefaultCompletedFilterDocument(today);
  if (showHabits) {
    return filterDocument;
  }

  return {
    ...filterDocument,
    [DocumentOrganizationKeys.Filters]: {
      ...filterDocument[DocumentOrganizationKeys.Filters],
      [FilterOptionKeys.Type]: {
        include: [TaskType.Task, TaskType.Repeating],
        noTag: false,
      },
    },
  };
};
